import React, { FunctionComponent, useEffect, useRef, memo } from 'react';
import { v4 as uuidv4 } from 'uuid';

import clientConfig from '../../client/config';
import isMobile from '../../utils/isMobile';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';

export interface PromptProps {
  entityId: string;
}

function loadPrompt(entityId: string, instanceId: string, userId?: string) {
  window.GG = {
    Prompt: {
      Requests: {
        FundraisingPageBanner: {
          userId,
          entityId,
          isMobile: isMobile(window),
        },
      },
    },
  };

  const script = document.createElement('script');

  script.src = `${clientConfig.promptServiceUrl}/script/FundraisingPageBanner?element=prompt-container-${instanceId}`;
  script.async = true;

  document.body.append(script);
}

const Prompt: FunctionComponent<PromptProps> = ({ entityId }) => {
  const { accessToken } = useAuthenticateUser();

  const instanceId = useRef(uuidv4());
  useEffect(() => {
    let userId;
    if (accessToken) {
      userId = accessToken.guid;
    }

    loadPrompt(entityId, instanceId.current, userId);
  }, [accessToken, entityId]);

  return <div id={`prompt-container-${instanceId.current}`} />;
};

export default memo(
  Prompt,
  (prevProps, nextProps) => prevProps.entityId === nextProps.entityId,
);
